import React from "react";
import PageHeader from "../../components/PageHeader";
import PartsTable from "./PartsTable";
import styles from "./Parts.module.css";

function Parts() {
  return (
    <div className={styles.container}>
      <PageHeader title="Parts" subtitle="Parts and services catalog" />

      <div className={styles.partsSection}>
        <div className={styles.sectionHeader}>
          <h2 className={styles.sectionTitle}>All parts</h2>
        </div>
        <div className={styles.tableContainer}>
          <PartsTable />
        </div>
      </div>
    </div>
  );
}

export default Parts;
